import { exportsModule } from '@cian/mf-registry/browser';
import { createCustomElementConstructor } from './createCustomElementConstructor';
import { createApplicationState } from '../services/applicationState';
import { createContext } from 'browser/services/runApp/createContext';

export function start() {
  const context = createContext();
  const store = createApplicationState(context);

  exportsModule({
    ui: {
      '/v1/get-b2c-login-widget': () => ({
        customElementConstructor: createCustomElementConstructor(context, store),
      }),
    },
    api: () => [],
  });
}
